import * as loadingActions from 'actions/Loading';

export default function reducer(
  state = {
    loading: false,
    taskQueue: [],
  },
  action
) {
  if (action.type.includes('REQUEST')) {
    return {
      ...state,
      loading: true,
      taskQueue: [...state.taskQueue, true],
    };
  }
  if (action.type.includes('SUCCESS') || action.type.includes('FAILURE')) {
    const taskQueue = [...state.taskQueue];
    if (taskQueue.length) taskQueue.shift();
    return {
      ...state,
      loading: !!taskQueue.length,
      taskQueue,
    };
  }
  if (action.type === loadingActions.SET_LOADING)
    return {
      ...state,
      loading: action.payload,
    };
  return state;
}
